import { render, staticRenderFns } from "./his-list.vue?vue&type=template&id=0360cb80&scoped=true&"
import script from "./his-list.vue?vue&type=script&lang=ts&"
export * from "./his-list.vue?vue&type=script&lang=ts&"
import style0 from "./his-list.vue?vue&type=style&index=0&id=0360cb80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360cb80",
  null
  
)

export default component.exports